import { Box, Button } from "@mui/material";
import { httpsCallable } from "firebase/functions";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useLocation, useParams } from "react-router-dom";
import { functions } from "../../../Firebase";
import ResponsiveDrawer from "../../Sidebar/HrSideBar";
// import Navbar from "../../Navbar/Navbar";
// import ResponsiveNavbar from "../../Navbar/ResponsiveNavbar";
import axios from "axios";
import { IP } from "../../../baseUrlAndConfig";
import { getCookie } from "../../../Cookies";
import HrTopNavbar from "../../Sidebar/HrTopNavbar";
import MobileTopBar from "../../Sidebar/MobaileTopBar";
import "../learning.css";
import { ItemContext } from "./Context/ItemContext";
import CourseContent from "./CoureContentMain/CourseContent";
import { CourseItem } from "./CoureContentMain/CourseItem";
import "./SingleCourseContentMain.css";
function SingleCourseContentMainHr() {
  const { t } = useTranslation();
  const location = useLocation();

  const sampleLessonId = location.state?.sampleLessonId;
  const getCourseInfo = httpsCallable(functions, "getCourseInfo");
  const getItemsArray = httpsCallable(functions, "getItemsArray");
  const getLastItemVisited = httpsCallable(functions, "getLastItemVisited");

  const navigate = useNavigate();
  const [showTab, setShowTab] = useState(1);
  const [itemsArray, setItemsArray] = useState([]); // quiz is also treated as item
  const [progressIndex, setProgressIndex] = useState(null);
  const [lastItemVisited, setLastItemVisited] = useState("");
  const [presentlessonName, setPresentlessonName] = useState("");
  // //console.log(showTab);

  const toggleTab = (index) => {
    setShowTab(index);
    //console.log(index);
  };

  const { courseId } = useParams();
  //console.log(courseId);
  // if courseId not defined send somewhere else

  // const [courseTree, setCourseTree] = useState();
  const [courseData, setCourseData] = useState(null);
  const [isLinear, setIsLinear] = useState(true);
  const [lessonsArray, setLessonsArray] = useState([]);

  async function fetchData() {
    let configrecrut = {
      method: "get",

      url: `${IP}/userCourseDetails/course`,
      params: { courseId: courseId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      //data: "dataregionf",
    };

    const response = await axios(configrecrut);

    console.log("cource data:", response.data);
    setCourseData(response.data);
    if (response.data.extraInfo.courseProgress == "linear") {
      if (sampleLessonId) return;
      setIsLinear(true);
    } else {
      setIsLinear(false);
    }
    setLessonsArray(response.data.extraInfo?.lessons);
  }

  //======================================================//

  const [loading, setLoading] = useState(true);

  // usePrompt("Do you want to leave ?", true);

  useEffect(() => {
    setLoading(true);
    if (sampleLessonId) {
      setIsLinear(false);

      let configrecrut = {
        method: "get",

        url: `${IP}/userItemDetails`,
        params: { lessonId: sampleLessonId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: "dataregionf",
      };
      axios(configrecrut)
        .then((result) => {
          setLoading(false);
          const itemsArray = result.data.filter((ele) => ele.type != "node");
          console.log(itemsArray);
          setItemsArray(itemsArray);
          if (progressIndex == null) setProgressIndex(0);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });

      return;
    }

    let configrecrut = {
      method: "get",

      url: `${IP}/userItemDetails`,
      params: { courseId: courseId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };
    axios(configrecrut).then(async (result) => {
      console.log(result.data);
      setLoading(false);
      let configrecrutf = {
        method: "get",

        url: `${IP}/userProgress/lastVisited`,
        params: { courseId: courseId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("bearer")}`,
        },
        data: "dataregionf",
      };

      axios(configrecrutf).then(async (lastItem) => {
        setLoading(false);
        console.log(lastItem);
        const itemsArray = result?.data;
        if (lastItem?.data?.itemId) {
          setItemsArray(itemsArray);
          if (lastItem.data.itemType === "video") setLastItemVisited("Video");
          if (lastItem.data.itemType === "pdf") setLastItemVisited("Pdf");
          if (lastItem.data.itemType === "quiz") setLastItemVisited("Quiz");
          if (lastItem.data.itemType === "html") setLastItemVisited("html");
          if (lastItem.data.itemType === "scorm") setLastItemVisited("scorm");
          let index = itemsArray.findIndex(
            (ele) => ele.id == lastItem.data.itemId,
          );
          let configrecrut = {
            method: "get",

            url: `${IP}/userItemDetails/nodeProgress`,
            params: { courseId: courseId },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getCookie("bearer")}`,
            },
            data: "dataregionf",
          };
          const res = await axios(configrecrut);

          if (location.state?.courseStatus) {
            console.log("itemsArray.length", itemsArray.length);
            setProgressIndex(itemsArray.length ? itemsArray.length - 1 : 0);
            //console.log("lastItem:", lastItem.data);
          } else if (res.data.completed == res.data.total) {
            setProgressIndex(res.data.completed);
            //console.log("lastItem:", lastItem.data);
          } else {
            setProgressIndex(index >= 0 ? index : 0);
            //console.log("lastItem:", lastItem.data);
          }
        } else {
          //console.log(itemsArray);
          setItemsArray(itemsArray);
          if (progressIndex == null) setProgressIndex(0);
        }
      });

      console.log(itemsArray);
    });
  }, [lastItemVisited]);

  useEffect(() => {
    fetchData();
  }, []);

  const lessonstatusname = () => {
    // console.log(itemsArray[progressIndex].name);
    console.log("progressIndex", progressIndex);
    console.log("itemsArray", itemsArray);

    if (progressIndex != null) {
      setPresentlessonName(
        itemsArray[progressIndex]?.name
          ? itemsArray[progressIndex]?.name
          : "course",
      );
    }
    // progressIndex
    // for (let i = progressIndex; i >= 0; i--) {
    //   if (itemsArray[i]?.headType == "lesson") {
    //     let str = "";
    //     if (itemsArray[i]?.name?.length > 40) {
    //       str = itemsArray[i]?.name?.slice(0, 35) + "....";
    //     } else {
    //       str = itemsArray[i]?.name;
    //     }
    //     setPresentlessonName(str);

    //     break;
    //   }
    // }
  };

  useEffect(() => {
    lessonstatusname();
  }, [progressIndex]);

  return (
    <Box
      className="hrmainbox"
      sx={{ backgroundColor: "#F3F1FF", width: "100%" }}
    >
      <Box className="mobileSideBar_leaning">
        <ResponsiveDrawer sidebar={"Learning"} />
      </Box>

      {loading && (
        <Box
          container
          spacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ mt: 10, ml: 40, alignItems: "center" }}
        >
          <div className="admin-overdue-bottom-table-cnt-c ">
            <div className="admin-overdue-bottom-table-td"></div>
            <div className="admin-overdue-bottom-table-td"></div>
            <div className="admin-overdue-bottom-table-td">
              <div className="spinner-container">
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    border: "10px solid #f3f3f3" /* Light grey */,
                    borderTop: "10px solid #007C84" /* Black */,
                    borderRadius: "50%",
                    animation: "spinner 1.5s linear infinite",
                    marginBottom: "200px",
                    marginTop: "120px",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </Box>
      )}

      {/* {JSON.stringify(progressIndex)} */}
      {!loading && (
        <ItemContext.Provider
          value={{
            courseId: courseId,
            itemsArray: itemsArray,
            progressIndex: progressIndex,
            setProgressIndex: setProgressIndex,
            sample: sampleLessonId,
            isLinear: isLinear,
            certificateInfo: location.state?.certificateInfo,
            courseStatus: location.state?.courseStatus,
            courseInfo: location?.state?.courseInfo,
          }}
        >
          <Box
            sx={{
              // ...responsiveFlexDirection,
              width: "100%",
              display: "flex",

              "@media (max-width: 780px)": {
                flexDirection: "column",
              },
              // gap: "15px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#f3f1ff",
              }}
            >
              <MobileTopBar />
              <HrTopNavbar
                title={
                  <Box
                    sx={{
                      zIndex: 3,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "50vw",
                      "&:hover": {
                        overflow: "visible",
                        whiteSpace: "normal",
                      },
                    }}
                  >
                    {" "}
                    {presentlessonName}
                  </Box>
                }
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  {!showTab && (
                    <Button
                      sx={{ color: "#6846C7", border: "1px solid #6846C7" }}
                      onClick={() => toggleTab(1)}
                    >
                      Course Content
                    </Button>
                  )}
                  <Button
                    onClick={() => {
                      navigate("/hr/Learning");
                    }}
                    sx={{ color: "#6846C7", border: "1px solid #6846C7" }}
                  >
                    Back
                  </Button>
                </Box>
              </HrTopNavbar>{" "}
              {/* contentbar */}
              {/* {showTab != 0 && (
                <Box
                  sx={{
                    minWidth: { xs: "100%", md: "25%" },
                    "@media (min-width: 600px)": {
                      display: "none",
                    },
                  }}
                >
                </Box>
              )} */}
              <Box
                sx={{
                  padding: "24px",
                  // "@media (max-width: 780px)": {
                  display: "flex",
                  width: "100%",
                  // },
                  "@media (max-width: 780px)": {
                    justifyContent: "center",
                  },
                }}
              >
                <Box
                  sx={{
                    // "@media (max-width: 780px)": {
                    display: "flex",
                    // },

                    width: "80%",
                    // "@media (max-width: 780px)": {
                    //   display: "none",
                    // },
                  }}
                >
                  <CourseItem typeOfScorm={courseData?.typeOfScorm} />
                </Box>
                {showTab != 0 && (
                  <Box
                    sx={{
                      margin: "24px",
                      // "@media (max-width: 780px)": {
                      width: "20%",
                      display: "flex",
                      // },
                      "@media (max-width: 780px)": {
                        display: "none",
                      },
                    }}
                  >
                    {showTab === 1 && (
                      <CourseContent
                        setShowTab={setShowTab}
                        lessons={courseData?.extraInfo?.lessons}
                        quizzes={courseData?.extraInfo?.quizzes}
                        courseInfo={location?.state?.courseInfo}
                      />
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          {/* {showTab != 0 && (
              <Box
                sx={{
                  minWidth: { xs: "100%", md: "25%", marginRight: "24px" },
                  "@media (max-width: 600px)": {
                    display: "none",
                  },
                  // order: 1,
                }}
              >
                {showTab === 1 && (
                  <CourseContent
                    setShowTab={setShowTab}
                    lessons={courseData?.extraInfo?.lessons}
                    quizzes={courseData?.extraInfo?.quizzes}
                    courseInfo={location?.state?.courseInfo}
                  />
                )}
              </Box>
            )} */}

          {/* <Box
              sx={{
                margin: "24px",
              }}
            >
              <CourseItem />
            </Box> */}
        </ItemContext.Provider>
      )}
    </Box>
  );
}

export default SingleCourseContentMainHr;
